"use client";

import { useState } from "react";
import toast from "react-hot-toast";
import ButtonBlueBorder from "@/app/components/appcomponents/ButtonBlueBorder";
import { PopupShell } from "@/app/components/appcomponents/thankYouWizard/parts";
import ObituaryPicker from "./ObituaryPicker";
import { STEP_ZERO_TITLES } from "./orderConfig";

/**
 * Step 0: choose the memory page. Only needed where the visitor does not come from a memory page
 * (the Cenik page and the home page); after it, the popups are the same as on a memory page.
 */
export default function StepZero({ product, onSelect, onClose }) {
  const [obituary, setObituary] = useState(null);

  const next = () => {
    if (!obituary) {
      toast.error("Izberi pokojno osebo s seznama");
      return;
    }
    onSelect(obituary);
  };

  return (
    <PopupShell title={STEP_ZERO_TITLES[product]} titleInside onClose={onClose}>
      <p className="mb-1 hidden text-[16px] leading-[24px] text-[#1E2125] mobile:block">Spominska stran:</p>
      <ObituaryPicker value={obituary} onChange={setObituary} />
      <div className="mx-auto mt-[40px] w-[250px] mobile:w-full">
        <ButtonBlueBorder placeholder="Naprej" onClick={next} />
      </div>
    </PopupShell>
  );
}
